/* eslint-disable no-unused-vars */
import { Scene, Input, Math as MathPhaser, Geom, Display } from "phaser";
import {
    backStaticAnimation, leftStaticAnimation, lightstickAnimation, mapHandler, reposeAnimation,
    rightStaticAnimation, turnStaticAnimation, upStaticAnimation, walkAnimation
} from '../../phaser/create';
import { walkHandler, directionHandler, randomDirection, lightstickHandler, setLastMovement } from '../../phaser/update';
import FullScreen from "../../phaser/components/fullScreen";
import PauseButton from "../../phaser/components/pauseButton";
import LightstickCounter from "../../phaser/components/lightstickCounter";
import ButtonPressed from "../../phaser/components/buttonPressed";
import { addButtonMove } from "../../phaser/components/buttonMove";
import SettingsButton from "../../phaser/components/settingsButton";
import CupFiller from "../../phaser/components/cupFiller";
import HelpButton from "../../phaser/components/helpButton";
import Joystick from "../../phaser/components/joystick";

let cursors;
let walls;

let characterSelected;
let objNames = {};
let footsteps;
let hearts = 1;
let totalHearts = 1;
let redHeartsObject = [];
let blackHeartsObject = [];
let gameSettings;
let hasLightstick = false;
let defaultSettings = 1;
let numberOfTouch = 0;
let instructionsHandler = 0;
let totalTimer = 90000;
let lastCoordenates = null;


export default class Game10 extends Scene {

    constructor() {
        super({ key: "Game10" });
    }
    init(data) {
        characterSelected = data.characterSelected;
        lastCoordenates = data.lastCoordenates;
        hasLightstick = false;
        redHeartsObject = [];
        blackHeartsObject = [];
        hearts = 1;
        this.firstStep = true;
        numberOfTouch = 0;
        this.events.off('buttonNext-dialogModal');
        this.startAll = false;
        setLastMovement('down');
        instructionsHandler = 0;
        totalTimer = 90000

    }

    preload() {
        if (this.sys.game.device.os.desktop) {
            console.log("desktop")
            this.isMobile = false;
        }
        else {
            this.isMobile = true;

            console.log("mobile")
        }
        cursors = this.input.keyboard.createCursorKeys();
    }

    create() {

        this.spaceBar = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.SPACE);
        this.pauseButton = this.input.keyboard.addKey(Input.Keyboard.KeyCodes.P);
        this.dialogModal = this.plugins.get('dialogModal');

        gameSettings = localStorage.getItem('sound');
        if (gameSettings === null) {
            localStorage.setItem('sound', 1);
            gameSettings = defaultSettings;
        }

        this.events.on('pause', () => {
            if(this.joystickManager) {
                this.joystickManager.pause();

            }
            this.isPause = true;
            this.startAll = false;
        });

        this.events.on(`resume`, (data, args) => {
            this.isPause = false;
            this.sound.mute = false;
            if (args) {
                footsteps.stop();
                this.ppalSong.stop();
                this.scene.stop();
                if (args.goHome) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Hallway`, { characterSelected: characterSelected, loadAgain: true });
                }

                if (args.goStart) {
                    if(this.joystickManager) {
                        this.joystickManager.destroyTest();
                        this.joystickManager = null;
                    }
                    this.events.off('buttonNext-dialogModal');

                    this.scene.start(`Start`);
                }
            } else {

                if(!this.showingInstruction) {
                    this.startAll = true;
                }

                if(this.isMobile) {
                    if(this.joystickManager) {
                        this.joystickManager.show();
                    }
                }

                gameSettings = localStorage.getItem('sound');
                if (gameSettings === '0') {
                    if (this.ppalSong.isPlaying) {
                        this.ppalSong.stop()
                    }
                } else {
                    if (!this.ppalSong.isPlaying) {
                        this.ppalSong.play();
                    }
                }
            }
        });

        this.cameras.main.setBounds(0, 0, 8904);
        this.physics.world.setBounds(0, 0, 8904);

        this.ppalSong = this.sound.add(`oddEyeSong`, { loop: true, volume: 0.2 });

        if (gameSettings === '1') {
            this.ppalSong.play();
        }

        this.map = mapHandler(this, 'game10', false, 8, 8);

        footsteps = this.sound.add(`footsteps`, { loop: true, rate: 2, volume: 0.2 });

        this.playing = false;
        walls = this.map.walls;
        walls.setScale(3);
        this.map.ground.setScale(3);

        this.object = this.map.map.createLayer('Objects', this.map.tileset, 0, 0);
        this.object.setCollisionByProperty({ collides: true });
        this.object.setScale(3);

        this.door = this.map.map.createLayer('Door', this.map.tileset, 0, 0);
        this.door.setCollisionByProperty({ collides: true });
        this.door.setScale(3);

        this.groundLightstick = this.map.map.createLayer('GroundExit', this.map.tileset, 0, 0).setVisible(false).setActive(false);
        this.groundLightstick.setCollisionByProperty({ collides: true });
        this.groundLightstick.setScale(3);        
        
        
        this.wallsLightstick = this.map.map.createLayer('WallsExit', this.map.tileset, 0, 0).setVisible(false).setActive(false);
        this.wallsLightstick.setCollisionByProperty({ collides: true });
        this.wallsLightstick.setScale(3);


        this.lightstick = this.physics.add.sprite(2424, 496, 'lightstick').setVisible(false).setActive(false).setScale(3);

        objNames[characterSelected] = this.physics.add.sprite(671, 2064, `${characterSelected}-game10`, 4).setDepth(1);
        objNames[characterSelected].setScale(2.5);
        objNames[characterSelected].setImmovable();
        // objNames[characterSelected].setBounce(1);

        this.add.graphics()
            .lineStyle(5, 0x00ffff, 0.5)

        walkAnimation(this, `${characterSelected}-game10`);
        reposeAnimation(this, `${characterSelected}-game10`);
        turnStaticAnimation(this, `${characterSelected}-game10`);
        upStaticAnimation(this, `${characterSelected}-game10`);
        leftStaticAnimation(this, `${characterSelected}-game10`);
        rightStaticAnimation(this, `${characterSelected}-game10`);
        backStaticAnimation(this, `${characterSelected}-game10`);
        lightstickAnimation(this, `${characterSelected}-game10`);

        // this.anims.create({
        //     key: `deadSpriteAnimation`,
        //     frames: this.anims.generateFrameNumbers('humo-game10', { start: 0, end: 16 }),
        //     frameRate: 7,
        //     repeat: -1
        // });

        this.physics.add.overlap(objNames[characterSelected], this.groundLightstick,
            function onOverlap() {
                if(this.groundLightstick.active) {
                    if(objNames[characterSelected].y < 2037) {
                        if(!this.hasZoom) {
                            this.cameras.main.fade(100, 0, 0, 0, false, (cam, progress) => {
                                if (progress === 1) {
                                    this.hasZoom = true;
                                    this.groundLightstick.setScale(1.5);
                                    walls.setScale(1.5);
                                    this.object.setScale(1.5);
                                    this.map.ground.setScale(1.5);
                                    this.wallsLightstick.setScale(1.5);
                                    objNames[characterSelected].setScale(1.5);
                                    objNames[characterSelected].x = objNames[characterSelected].x / 2;
                                    objNames[characterSelected].y = objNames[characterSelected].y / 2;
                                    this.lightstick.setVisible(true).setActive(true);
                                    this.cameras.main.fadeIn();
                                }
                            });
    
                        }
                    }
    
                    if(this.hasZoom) {
                        clearTimeout(this.timeoutOverlap);
                        this.timeoutOverlap = setTimeout(() => {
                        this.hasZoom = false;
                        this.cameras.main.fade(100, 0, 0, 0, false, (cam, progress) => {
                            if (progress === 1) {
                                objNames[characterSelected].setScale(2.5);
                                objNames[characterSelected].x = objNames[characterSelected].x * 2;
                                objNames[characterSelected].y = objNames[characterSelected].y * 2;
                                this.groundLightstick.setScale(3);
                                this.wallsLightstick.setScale(3);
                                this.lightstick.setVisible(false).setActive(false);
        
                                walls.setScale(3);
                                        this.object.setScale(3);
                                        this.map.ground.setScale(3);
                                this.cameras.main.fadeIn();
                            }
                        });
                        }, 100);
                    }

                }

            }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );


        this.physics.add.overlap(objNames[characterSelected], this.lightstick,
            function onOverlap() {
                if (this.lightstick.active) {
                    this.instructionMessage.visible = true;
                    if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {

                        this.startAll = false;
                        this.showingInstruction = true;
                        // objNames[characterSelected].active = false;
                        objNames[characterSelected].anims.play(`repose-${characterSelected}-game10`);
                        // this.dialogModal._createWindow(this, 'dialog-win', null, true);
                        this.dialogModal._createImageDialog(this, 'dialog-win');

                        this.dialogModal.setText("I knew it was here! \nNow, it's time to make my way back".toUpperCase(), `${characterSelected}-hallway`, false, false);

                    }

                    clearTimeout(this.timeoutInstruction);


                    this.timeoutInstruction = setTimeout(() => {
                        this.instructionMessage.visible = false;
                    }, 100);

                }

            }.bind(this),
            function process(sprite, tile) {
                return tile.collides;
            }
        );

        this.collidesWalls = this.physics.add.collider(objNames[characterSelected], walls);
        this.physics.add.collider(objNames[characterSelected], this.wallsLightstick);

        this.physics.add.collider(objNames[characterSelected], this.object);
        this.doorCollider = this.physics.add.collider(objNames[characterSelected], this.door);
        // this.physics.add.collider(dobleEnemy, this.object);


        this.cameras.main.startFollow(objNames[characterSelected], true);

        // INICIO ANIMACIONES EN GRUPO DE MISMO SPRITE DEL MISMO OBJETO
        this.cupsFillsRoom1 = this.physics.add.group();
        this.cupsNoFillsRoom1 = this.physics.add.group();

        this.cupsFillsRoom2 = this.physics.add.group();
        this.cupsNoFillsRoom2 = this.physics.add.group();
        
        this.cupsFillsRoom3 = this.physics.add.group();
        this.cupsNoFillsRoom3 = this.physics.add.group();
        
        this.cupsFillsRoom4 = this.physics.add.group();
        this.cupsNoFillsRoom4 = this.physics.add.group();
        
        this.cupsFillsRoom5 = this.physics.add.group();
        this.cupsNoFillsRoom5 = this.physics.add.group();

        
        // this.anims.create({
        //     key: `plant-move`,
        //     frames: this.anims.generateFrameNumbers(`plant`, { start: 0, end: 3 }),
        //     frameRate: 7,
        //     repeat: -1
        // });

        for (var i = 0; i < 4; i++) {
            var x1 = MathPhaser.RND.between(56, 1096); 
            var y1 = MathPhaser.RND.between(359, 1081); 
            var x1nofill = MathPhaser.RND.between(56, 1096); 
            var y1nofill = MathPhaser.RND.between(359, 1081); 
            this.cupsFillsRoom1.create(x1, y1, 'copa1-game10').setScale(2.5).setImmovable();
            this.cupsNoFillsRoom1.create(x1nofill, y1nofill, 'copa2-game10').setScale(2.5).setImmovable();
            var x2 = MathPhaser.RND.between(1496, 1875); 
            var y2 = MathPhaser.RND.between(1876, 2161); 
            var x2nofill = MathPhaser.RND.between(1496, 1875); 
            var y2nofill = MathPhaser.RND.between(1876, 2161);
            this.cupsFillsRoom2.create(x2, y2, 'copa1-game10').setScale(2.5).setImmovable();
            this.cupsNoFillsRoom2.create(x2nofill, y2nofill, 'copa2-game10').setScale(2.5).setImmovable();
            var x3 = MathPhaser.RND.between(2960, 3689); 
            var y3 = MathPhaser.RND.between(1639, 2161); 
            var x3nofill = MathPhaser.RND.between(2960, 3689); 
            var y3nofill = MathPhaser.RND.between(1639, 2161);
            this.cupsFillsRoom3.create(x3, y3, 'copa1-game10').setScale(2.5).setImmovable();
            this.cupsNoFillsRoom3.create(x3nofill, y3nofill, 'copa2-game10').setScale(2.5).setImmovable();
            var x4 = MathPhaser.RND.between(2840, 3688); 
            var y4 = MathPhaser.RND.between(647, 1033); 
            var x4nofill = MathPhaser.RND.between(2840, 3688); 
            var y4nofill = MathPhaser.RND.between(647, 1033);         
            this.cupsFillsRoom4.create(x4, y4, 'copa1-game10').setScale(2.5).setImmovable();
            this.cupsNoFillsRoom4.create(x4nofill, y4nofill, 'copa2-game10').setScale(2.5).setImmovable();
            var x5 = MathPhaser.RND.between(1526, 2433); 
            var y5 = MathPhaser.RND.between(382, 1009); 
            var x5nofill = MathPhaser.RND.between(1526, 2433); 
            var y5nofill = MathPhaser.RND.between(382, 1009); 
            this.cupsFillsRoom5.create(x5, y5, 'copa1-game10').setScale(2.5).setImmovable();
            this.cupsNoFillsRoom5.create(x5nofill, y5nofill, 'copa2-game10').setScale(2.5).setImmovable();
        }

        this.physics.add.collider(objNames[characterSelected], this.cupsFillsRoom1, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    this.cupFiller.increase(MathPhaser.RND.between(1, 8));
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }

        }, null, this);
        this.physics.add.collider(objNames[characterSelected], this.cupsNoFillsRoom1, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(0, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }

        }, null, this);
        
        this.physics.add.collider(objNames[characterSelected], this.cupsFillsRoom2, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(1, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }
        }, null, this);
        this.physics.add.collider(objNames[characterSelected], this.cupsNoFillsRoom2, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(0,8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }
        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.cupsFillsRoom3, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(1, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }

        }, null, this);
        this.physics.add.collider(objNames[characterSelected], this.cupsNoFillsRoom3, (obj, cup) => {
            if(cup.visible) {
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(1, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }

        }, null, this);
        
        this.physics.add.collider(objNames[characterSelected], this.cupsFillsRoom4, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(0, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);
            }
        }, null, this);
        this.physics.add.collider(objNames[characterSelected], this.cupsNoFillsRoom4, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(1, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }
        }, null, this);

        this.physics.add.collider(objNames[characterSelected], this.cupsFillsRoom5, (obj,cup) => {
            if(cup.visible) {
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(0, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }

        }, null, this);
        this.physics.add.collider(objNames[characterSelected], this.cupsNoFillsRoom5, (obj, cup) => {
            if(cup.visible) {
                this.instructionMessage.visible = true;
                if ((!this.isMobile && this.spaceBar.isDown) || (this.isMobile && this.buttonAction.isDown)) {
                    if(this.cupFiller.increase(MathPhaser.RND.between(0, 8))) {
                        this.stopCron()
                    }
                    cup.setVisible(false)
                }
    
                clearTimeout(this.timeoutInstruction);
    
                this.timeoutInstruction = setTimeout(() => {
                    this.instructionMessage.visible = false;
                }, 100);

            }

        }, null, this);

        this.buttonFullscreen = new FullScreen(this);
        this.buttonSettings = new SettingsButton(this);
        this.buttonPause = new PauseButton(this, characterSelected);
        this.buttonHelp = new HelpButton(this);

        window.addEventListener("blur", () => {
            this.isPause = true;
            this.buttonPause.pauseByEvent();
        });

        // document.addEventListener('visibilitychange', () => {
        //     if (document.visibilityState !== 'visible') {
        //         this.isPause = true;
        //         this.buttonPause.pauseByEvent();
        //     }
        // });

        objNames[characterSelected].anims.play(`repose-${characterSelected}-game10`);
        // this.dialogModal._createWindow(this, 'first-dialog', null, true);
        this.dialogModal._createImageDialog(this, 'first-dialog');
        this.showingInstruction = true;
        this.dialogModal.setText("What is this place? It seems like a utopia...".toUpperCase(), `${characterSelected}-hallway`, false, false)

        this.events.on('buttonNext-dialogModal', (data) => {
            instructionsHandler++;
            let total = JSON.parse(localStorage.getItem('noL'));

            switch (data.id) {
                case 'first-dialog':
                    switch (instructionsHandler) {
                        case 1:
                            this.dialogModal.setText("Why am I so thirsty?".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 2:
                            this.dialogModal.setText("I need to find something to drink before continuing with my mission.".toUpperCase(), `${characterSelected}-hallway`, false, false);
                            break;
                        case 3:
                            this.dialogModal.close();
                            this.startAll = true;
                            this.showingInstruction = false;

                            if(this.isMobile) {
                                this.joystickManager = new Joystick(objNames[characterSelected], `${characterSelected}-game10`, 300);
                                this.joystickManager.createJoystick();
                                this.joystickManager.activate(hasLightstick);
                            }
                            this.cupFiller.setVisible(true);
                            instructionsHandler = 0;
                            this.countdownText.visible = true;
                            this.countdown = setInterval(() => {
                                if (!this.isPause) {
                                    totalTimer -= 1000;
                                }
                                if (totalTimer <= 0) {
                                    this.startAll = false;
                                    clearInterval(this.countdown);
                                    this.updateCounter();
                                }
                            }, 1000);

                            break;
                    }
                    break;
                case 'dialog-show-lightstick':
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    this.startAll = true;
                    this.showingInstruction = false;

                    break;
                case 'dialog-win':
                    this.dialogModal.close();
                    instructionsHandler = 0;
                    if (total) {
                        if (!total.includes(10)) {
                            total.push(10);
                            localStorage.setItem('noL', JSON.stringify(total));

                        }
                    } else {
                        localStorage.setItem('noL', JSON.stringify([10]));
                    }

                    this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                        if (progress === 1) {
                            footsteps.stop();
                            this.ppalSong.stop();
                            this.scene.stop();
                            this.events.off('buttonNext-dialogModal');

                            this.scene.start(`Win`, { characterSelected: characterSelected, level: 10, lastCoordenates });
                        }
                    });
                    break;
            }

        }, this);

        if (this.isMobile) {
            this.buttonAction = new ButtonPressed(this, 700, 500 - 51, `buttonAction`);
            this.buttonAction.setScale(2);
            this.add.existing(this.buttonAction);
        }

        let x = 0;
        let y = 16;
        for (let i = 0; i < totalHearts; i++) {
            if (i === 0) {
                x += 40;
            } else {
                x += 30;
            }
            blackHeartsObject.push(this.add.image(x, y, `heartBlack`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
            redHeartsObject.push(this.add.image(x, y, `heartRed`, 0).setScale(3).setOrigin(1, 0).setScrollFactor(0));
        }

        this.countdownText = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 40, 20, 'pixelfont',`${this.convertTimer()} SEG`.toUpperCase(), 10, 1).setTint(0xFFFFFF).setDepth(1).setOrigin(1, 0).setScrollFactor(0).setScale(1.5).setVisible(false);
        this.lightstickCounter = new LightstickCounter(this);
        this.instructionMessage = this.add.bitmapText((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 120, 40, 
            'pixelfont', "Interact: spacebar/action button".toUpperCase(), 10,1).setTint(0xffffff).setOrigin(1, 0).setScale(1).setVisible(false).setScrollFactor(0);
        // this.instructionMessage = this.add.text((this.cameras.main.worldView.x + this.cameras.main.width / 2) + 100, 16, 'INTERACT: SPACEBAR', { font: "30px CustomFont", fill: "#FFF", stroke: "#101820", strokeThickness: 3 }).setVisible(false).setOrigin(1, 0).setScrollFactor(0);
        this.cupFiller = new CupFiller(this, 35, 90, 'copa1-game10');
        this.cupFiller.setScrollFactor(0);
        this.cupFiller.setVisible(false);


    }

    stopCron() {
        this.startAll = false;
        objNames[characterSelected].setVelocity(0);
        objNames[characterSelected].anims.play(`repose-${characterSelected}-game10`, true);
        this.cupsFillsRoom1.setActive(false)
        this.cupsFillsRoom1.setVisible(false)
        this.cupsNoFillsRoom1.setActive(false)
        this.cupsNoFillsRoom1.setVisible(false);

        this.cupsFillsRoom2.setActive(false)
        this.cupsFillsRoom2.setVisible(false);
        this.cupsNoFillsRoom2.setActive(false)
        this.cupsNoFillsRoom2.setVisible(false);
        
        this.cupsFillsRoom3.setActive(false)
        this.cupsFillsRoom3.setVisible(false);
        this.cupsNoFillsRoom3.setActive(false)
        this.cupsNoFillsRoom3.setVisible(false);
        
        this.cupsFillsRoom4.setActive(false)
        this.cupsFillsRoom4.setVisible(false);
        this.cupsNoFillsRoom4.setActive(false)
        this.cupsNoFillsRoom4.setVisible(false);
        
        this.cupsFillsRoom5.setActive(false)
        this.cupsFillsRoom5.setVisible(false);
        this.cupsNoFillsRoom5.setActive(false)
        this.cupsNoFillsRoom5.setVisible(false);
        clearInterval(this.countdown);
        this.countdownText.setVisible(false);
        this.physics.world.removeCollider(this.doorCollider);
        this.groundLightstick.setActive(true);
        this.groundLightstick.setVisible(true);
        this.wallsLightstick.setActive(true);
        this.wallsLightstick.setVisible(true);
        this.cupFiller.setVisible(false);

        this.showingInstruction = true;
        // this.dialogModal._createWindow(this, 'dialog-show-lightstick', null, true);
        this.dialogModal._createImageDialog(this, 'dialog-show-lightstick');

        this.dialogModal.setText("It's odd, I suddenly feel fulfilled. \nFinding the lightstick is crucial now. \nI don't know why, but I believe the lightstick is near a large tree…".toUpperCase(), `${characterSelected}-hallway`, false, false);
    }

    updateCounter() {
        this.tweens.add({
            targets: redHeartsObject[hearts - 1],
            alpha: 0,
            scaleX: 0,
            scaleY: 0,
            ease: 'Linear',
            duration: 200
        });

        var heartsTimeline = this.tweens.createTimeline();

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 1.5,
            scaleY: 1.5,
            ease: 'Power1',
            duration: 200
        });

        heartsTimeline.add({
            targets: blackHeartsObject[hearts - 1],
            scaleX: 3,
            scaleY: 3,
            ease: 'Power1',
            duration: 200
        });
        heartsTimeline.play();
        hearts -= 1;
        setTimeout(() => {
            if (hearts <= 0) {
                this.cameras.main.fade(1000, 0, 0, 0, false, (cam, progress) => {
                    if (progress === 1) {
                        footsteps.stop();
                        this.ppalSong.stop();
                        this.scene.stop();
                        if(this.joystickManager) {
                            this.joystickManager.destroyTest();
                            this.joystickManager = null;
                        }
                        this.events.off('buttonNext-dialogModal');
                        this.scene.start(`GameOver`, { characterSelected: characterSelected, level: 10, lastCoordenates });
                    }
                });
            }

            objNames[characterSelected].clearTint();
            objNames[characterSelected].alpha = 1;
            totalTimer = 30;
            this.countdown = setInterval(() => {

                totalTimer--;
                // If the count down is finished, write some text
                if (totalTimer <= 0) {
                    clearInterval(this.countdown);
                    this.updateCounter();
                }
            }, 1000);
            // handleDamage = false;

        }, 1000);

    }

    convertTimer() {
        let seconds;
        let minutes;

        minutes = Math.floor((totalTimer / 60000));
        seconds = ((totalTimer % 60000) / 1000).toFixed(0);
        seconds = (seconds < 10 ? '0' : '') + seconds;

        return `${minutes} : ${seconds} ${minutes > 0 ? "MIN" : "SEG"}`;
    }

    update() {

        if (this.startAll) {

            // this.instructionMessage.setPosition(this.screenCenterX, 60)

            if (this.isMobile) {
                if(this.joystickManager) {
                    this.joystickManager.show();
                }
            } else {
                walkHandler(cursors, objNames[characterSelected], 300, `${characterSelected}-game10`, hasLightstick);
            }

            if (this.countdownText.visible) {
                this.countdownText.setText(this.convertTimer());
            }



            if ((!this.isMobile && (cursors.left.isDown || cursors.right.isDown || cursors.up.isDown || cursors.down.isDown))) {
                if (this.playing !== true) {
                    if (gameSettings === '1') {

                        footsteps.play();
                        this.playing = true;
                    }
                }

            } else {
                this.playing = false;
                footsteps.stop();
            }

        }else {
            if(this.isMobile) {
                if(this.joystickManager) {
                    objNames[characterSelected].setVelocity(0, 0);
                    objNames[characterSelected].anims.play(`repose-${characterSelected}-game10`);
                    this.joystickManager.pause();
                }
            }
        }


    }

}